import get from 'lodash/get'
import { ICarrierApplicationStates, Maybe } from 'types/graphqlTypes'
import { CARRIER_STATE_LABEL, TCarrierStateLabels } from './types'

export function getCarrierStateLabel<K extends ICarrierApplicationStates>(
  stateType: Maybe<K>
): TCarrierStateLabels[K] | null {
  if (stateType) {
    return get(CARRIER_STATE_LABEL, stateType)
  }
  return null
}
